import { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Background from './components/Background';
import MainPage from './components/MainPage';
import Intro from './components/Intro';
import ResumePage from './components/ResumePage';

// Inner component to handle location-based transitions
const AppContent = () => {
  const location = useLocation();
  // We only show intro if we are at root "/" and it hasn't been shown yet
  // However, simple approach: Local state for intro.
  const [showIntro, setShowIntro] = useState(true);

  // If user navigates to /resume directly, maybe skip intro?
  // Or if we go back to home, should we show intro? User said "Home (returns to the home, skip the animation)"
  // So we should effectively disable intro after first load or if navigating back.

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={
          showIntro ? (
            <Intro key="intro" onComplete={() => setShowIntro(false)} />
          ) : (
            <MainPage key="main" />
          )
        } />
        <Route path="/resume" element={<ResumePage />} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <Router>
      <div className="app-container">
        <Background />
        <AppContent />
      </div>
    </Router>
  );
}

export default App;
